export default {
  lang: 'Idioma',
  currency: 'Moeda',
  validGoodUrlFail: 'Este não é um link de produto correto',
  product: 'Produto',
  productHolder: 'Inserir nome/link do produto',
  shop: 'Loja',
  shopHolder: 'Inserir nome/link da loja',
  purchaseAgent: 'Início',
  transport: 'Reenvio',
  manualOrdering: 'Pedido manual',
  guideBook: 'Manual de guia',
  help: 'Ajuda',
  tools: 'Ferramentas',
  customerService: 'Atendimento ao cliente',
  purchaseGuide: 'Guia de compra',
  payment: 'Pagamento',
  delivery: 'Entrega',
  afterSaleService: 'Serviço pós-venda',
  insuranceCompensation: 'Seguro e compensação',
  contactInfo: 'Informações de contato',
  enterEmail: 'Insira seu e-mail',
  copyRight: 'Todos os direitos reservados ©acbuy.com',
  aboutacbuy: 'Sobre acbuy',
  contctTime: '9/7 (09:00-18:00, horário de Pequim)',
  contactEmail: "E-mail de atendimento: Support{'@'}acbuy.com",
  contactMarket: "Cooperação de mercado: Marketing{'@'}acbuy.com",
  contactCooperation: "Cooperação comercial: Business{'@'}acbuy.com",
  tutorial: 'Tutorial',
  serviceFee: 'Taxa de serviço',
  orderStatus: 'Guia para iniciantes',
  returnRefunds: 'Devolução e reembolso',
  topUp: 'Recarga',
  paypal: 'PayPal',
  internationalCreditCard: 'Cartão de crédito internacional',
  telegraphicTransfer: 'Transferência bancária',
  charges: 'Taxas',
  mailRestrictions: 'Restrições de envio',
  customsTaxation: 'Alfândega e impostos',
  receiptInformation: 'Informações de recibo',
  helpCenter: 'Centro de Ajuda',
  contactUs: 'Entre em contato',
  registerSuccess: 'Registro bem-sucedido',
  registerMsg:
    'Enviamos um e-mail de verificação para seu e-mail. Por favor, complete a verificação a tempo, caso contrário, afetará o uso normal de seus pontos.',
  continueShopping: 'Continuar comprando',
  continueLogin: 'Continuar login',
  verifyQuestion: 'Não recebeu o e-mail de verificação?',
  verifyResopnseOne:
    '· O e-mail de verificação acbuy pode ser erroneamente identificado como spam, por favor, verifique sua pasta de spam',
  verifyResopnseTwo: '· O envio pode ser atrasado por alguns minutos, por favor, seja paciente',
  verifyResopnseThird:
    '· O e-mail de verificação pode ser atrasado por alguns minutos. Se não receber o e-mail por muito tempo, você pode verificar se foi marcado como spam ou reenviar o e-mail de verificação',
  agentGuide: 'Guia de compra para iniciantes',
  guideBookbtn: 'Manual de guia para iniciantes',
  everyonePro: 'Registre-se agora e receba um presente de boas-vindas de ¥2280!',
  joinAffiliate: 'Receber',
  joinacbuy: 'Junte-se ao Discord acbuy para mais benefícios',
  joinDiscord: 'Juntar-se ao Discord',
  productPpurchase: 'Compra de produtos',
  shippingToWarehouse: 'Envio para armazém',
  qualityAssurance: 'Garantia de qualidade',
  moreCostEffective: 'Mais econômico',
  productPpurchaseContent:
    'Compra de produtos - Você pode comprar facilmente qualquer produto do Taobao. Basta colar o link do produto Taobao no site acbuy e fazer o pedido, o acbuy comprará para você.',
  shippingToWarehouseContent:
    'Envio para armazém - Compre de diferentes vendedores através do nosso serviço, integraremos seus pedidos de compra de forma eficiente. Todos os produtos serão enviados para o armazém designado acbuy, simplificaremos o processo e forneceremos conveniência para você.',
  qualityAssuranceContent:
    'Garantia de qualidade - Quando seus produtos chegarem ao armazém designado acbuy, faremos uma inspeção completa de qualidade dos seus produtos e enviaremos feedback de inspeção para você, fornecendo uma melhor experiência de uso.',
  moreCostEffectiveContent:
    'Transporte consolidado economiza dinheiro - No seu armazém, você pode escolher produtos livremente e enviar através de um pacote. Usando o serviço de transporte global acbuy, você pode enviar produtos para qualquer lugar, desfrutando de transporte global mais simples e confiável.',
  introduction: 'Comprar no Taobao através do acbuy',
  logoIntroduction: 'Shop like a millionaire.',
  reviewOn: 'Comentários',
  productStoragePeriod: 'Período de armazenamento do produto',
  inspectionRules: 'Regras de inspeção',
  afterSalesPolicy: 'Política pós-venda',
  insuranceAndCompensation: 'Seguro e compensação',
  oneStopService: 'Serviço completo',
  whatCustomersSay: 'Avaliações de usuários',
  customerSay1:
    'acbuy é o melhor agente de compras que já usei - esta é minha primeira vez usando acbuy, seus produtos são mais baratos do que qualquer outro agente de compras, isso é incrível!',
  customerSay2:
    'Depois de me tornar um promotor acbuy, recebi um reembolso em dinheiro de 300 yuan. Depois disso, receberei um reembolso em dinheiro de pelo menos 4% em cada pedido',
  customerSay3:
    'Experiência de compra muito agradável - Usei acbuy para comprar da China, boa qualidade do produto, bom atendimento ao cliente, envio rápido.',
  customerSay4:
    'Melhor agente - A compra foi concluída no mesmo dia. Levou apenas 7 dias para entregar o pacote em minha casa. Este é o melhor agente atualmente',
  customerFirst: 'Cliente em primeiro lugar, serviço de qualidade',
  customerServiceText: 'Atendimento online 9/7 (09:00-18:00, horário de Pequim)',
  faqCategory: 'Categoria FAQ',
  valentine: 'Surpresa de caixa misteriosa do Dia dos Namorados',
  joinDiscordNew: 'Clique para juntar-se',
  valentineTip: 'Junte-se ao Discord para obter presentes exclusivos',
  inviteNow: 'Convidar agora',
  inviteMore: 'Quanto mais você convida, mais você ganha!',
  comeHere: 'Mais recompensas incríveis esperando por você!',
  viewTutorial: 'Ver tutorial',
  springText1: 'Como comprar no Taobao através do Acbuy',
  springText2: 'Convide amigos e ganhe recompensa em dinheiro de ¥2000',
  springText3: 'Período da atividade: 18 de abril - 20 de maio',
  category: 'Categoria',
  hotSale: 'Produtos em alta',
  motherText1: 'Oferta exclusiva do Dia das Mães',
  motherText2: 'Ganhe prêmios - Participe agora!',
  motherText3: 'Período da atividade: 30 de abril - 13 de maio',
  enterNow: 'Participar agora',
  'i18n-000001': 'Fazer pedido',
  'i18n-000002': 'Cole o link do produto para enviar o pedido',
  'i18n-000003': 'Inspeção de qualidade e armazenamento',
  'i18n-000004': 'Fornece 3-5 fotos de QC e 90 dias de armazenamento gratuito',
  'i18n-000005': 'Enviar pacote',
  'i18n-000006': 'Empacotamento combinado e verificação de pacote',
  'i18n-000007': 'Logística internacional',
  'i18n-000008': 'Mais de 150 rotas de logística baratas',
  loveText1: 'Junte-se à atividade 520',
  loveText2: 'Quanto mais pedidos, maior a recompensa!',
  loveText3: 'Período da atividade: 14 de maio - 24 de maio',
  couponResult: 'Encontrados {num} resultados de "{keyword}"',
  event: 'Atividade',
}
